/**
 * Cell text for the cuadro. Formulario Orígenes show the ID trouble ticket.
 * Red/Huawei keeps Oceane in the cell. Red keeps Oceane when it has one.
 */
export function incidentCellText({dominio, ttNumber, oceane}) {
  const id = ttNumber == null ? '' : String(ttNumber);
  const oceaneText = oceane == null ? '' : String(oceane).trim();
  if (dominio === 'Red/Huawei') {
    return oceaneText || 'Pdte. Oceane';
  }
  if (dominio === 'Red') {
    return oceaneText || id;
  }
  return id;
}

/**
 * Joint reading of an incidencia. Oceane beside the ID only when it is a different identifier.
 */
export function incidentPairText(inc, oceane) {
  const id = inc == null ? '' : String(inc).trim();
  const oceaneId = oceane == null ? '' : String(oceane).trim();
  if (!oceaneId || oceaneId === id) return id;
  return `${id} / ${oceaneId}`;
}

/** Detail title. Oceane is shown beside the ID when the alarm has a different one. */
export function incidentDetailTitle(inc, oceane, dominio) {
  const id = inc == null ? '' : String(inc).trim();
  const oceaneId = oceane == null ? '' : String(oceane).trim();
  if (!oceaneId && dominio === 'Red/Huawei') {
    return id ? `${id} / Pdte. Oceane` : 'Pdte. Oceane';
  }
  return incidentPairText(inc, oceane);
}
